import { deviceId } from '@/lib/device-id'

/** Browser and OS names only, never the full user agent: the backend ignores values over 64 characters. */
export function browserName(ua: string): string {
  if (/Edg(e|A|iOS)?\//.test(ua)) return 'Edge'
  if (/OPR\/|Opera/.test(ua)) return 'Opera'
  if (/SamsungBrowser\//.test(ua)) return 'Samsung Internet'
  if (/Firefox\/|FxiOS\//.test(ua)) return 'Firefox'
  if (/Chrome\/|CriOS\//.test(ua)) return 'Chrome'
  if (/Safari\//.test(ua)) return 'Safari'
  return 'Unknown browser'
}

export function osName(ua: string): string {
  if (/iPhone|iPad|iPod/.test(ua)) return 'iOS'
  if (/Android/.test(ua)) return 'Android'
  if (/CrOS/.test(ua)) return 'ChromeOS'
  if (/Windows/.test(ua)) return 'Windows'
  if (/Mac OS X|Macintosh/.test(ua)) return 'macOS'
  if (/Linux/.test(ua)) return 'Linux'
  return 'Unknown OS'
}

/** The identity headers of the frozen LP-938 contract, sent on every request including the token refresh. */
export function clientHeaders(): Record<string, string> {
  const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent
  return {
    'X-Client-Platform': 'web',
    'X-App-Version': __APP_BUILD__,
    'X-Device-Id': deviceId(),
    'X-Device-Model': browserName(ua),
    'X-OS-Version': osName(ua),
  }
}
